import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import SectionTabs from "../../../components/ui/common/SectionTabs";
import HistoryImage from "../../../resources/images/background/intro/history1.png";
import { chapter1 } from "../../../context/intro/history/chapter1";
import { chapter2 } from "../../../context/intro/history/chapter2";
import { chapter3 } from "../../../context/intro/history/chapter3";
import HistoryChapter from "../../../components/ui/intro/history/HistoryChapter";
import PageTemplate from "../../../components/ui/common/template/PageTemplate";
import UseScroll from "../../../components/hooks/ui/UseScroll";
import { Link } from "react-scroll";
import UseBreakpoints from "../../../components/hooks/ui/UseBreakpoints";
const HistoryPage = () => {
  const breakpoints = UseBreakpoints();
  const scroll = UseScroll();
  const posRefs = [useRef(), useRef(), useRef()];
  // X
  const [sectionPos, setSectionPos] = useState([]);
  const [inSection, setInSection] = useState([]);

  // Get the position of the red box in the beginning
  useEffect(() => {
    const getPosition = () => {
      setSectionPos(
        posRefs?.map((ref) => {
          return {
            x: ref.current?.offsetLeft ? ref.current?.offsetLeft : 0,
            y: ref.current?.offsetTop ? ref.current?.offsetTop : 0,
          };
        })
      );
    };
    getPosition();
    window.addEventListener("resize", getPosition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Re-calculate X and Y of the red box when the window is resized by the user
  useEffect(() => {
    setInSection([
      scroll?.y >= sectionPos[0]?.y - 388 && scroll?.y < sectionPos[1]?.y - 388,
      scroll?.y >= sectionPos[1]?.y - 388 && scroll?.y < sectionPos[2]?.y - 388,
      scroll?.y >= sectionPos[2]?.y - 388,
    ]);
  }, [sectionPos, scroll]);
  return (
    <PageTemplate
      title="연혁"
      image={HistoryImage}
      phrase={"관세법인의 새로운 역사를 쓰다."}
      large aone
    >
      <PageDiv>
        <SectionTabs breakpoints={breakpoints} inSection={inSection}>
          <Link smooth offset={-250} to="section-1">
            {chapter1.title}
          </Link>
          <Link smooth offset={-250} to="section-2">
            {chapter2.title}
          </Link>
          <Link smooth offset={-250} to="section-3">
            {chapter3.title}
          </Link>
        </SectionTabs>
        <HistoryDiv>
          <section id="section-1" name="section-1" ref={posRefs[0]}>
            <HistoryChapter context={chapter1} />
          </section>
          <section id="section-2" name="section-2" ref={posRefs[1]}>
            <HistoryChapter context={chapter2} />
          </section>
          <section id="section-3" name="section-3" ref={posRefs[2]}>
            <HistoryChapter context={chapter3} />
          </section>
        </HistoryDiv>
      </PageDiv>
    </PageTemplate>
  );
};
export default HistoryPage;
const PageDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2rem;
`;
const HistoryDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
